document.addEventListener('DOMContentLoaded', () => {
  const revealTargets = document.querySelectorAll('.artwork-installation, .price-matrix__item, .universe-wing, .proof-image');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    revealTargets.forEach((target) => observer.observe(target));
  } else {
    revealTargets.forEach((target) => target.classList.add('is-visible'));
  }

  const parallaxItems = document.querySelectorAll('[data-slow-parallax]');
  const archiveReveal = document.querySelector('[data-archive-reveal]');
  const archiveItems = document.querySelectorAll('.visitor-archive--simple .visitor-photo');
  const archiveFilters = document.querySelectorAll('[data-archive-filter]');
  const archiveLightbox = document.querySelector('[data-archive-lightbox]');
  const lightboxImage = archiveLightbox ? archiveLightbox.querySelector('img') : null;
  const lightboxClose = document.querySelector('[data-lightbox-close]');
  const lightboxNext = document.querySelector('[data-lightbox-next]');
  const lightboxPrev = document.querySelector('[data-lightbox-prev]');
  let activeArchiveFilter = 'all';
  let archiveExpanded = false;
  let activeLightboxIndex = 0;

  const reportArchiveCounts = () => {
    if (!archiveItems.length || window.__streetArchiveReported) return;

    const counts = Array.from(archiveItems).reduce((totals, item) => {
      const category = item.dataset.category || 'other';
      totals[category] = (totals[category] || 0) + 1;
      return totals;
    }, {});

    window.__streetArchiveReported = true;
    console.info('Street Archive report', {
      totalImagesFound: archiveItems.length,
      assignedByGroup: counts,
      otherGiants: counts['other-giants'] || 0
    });
  };

  const applyArchiveFilter = () => {
    archiveItems.forEach((item) => {
      const matchesFilter = activeArchiveFilter === 'all' || item.dataset.filter === activeArchiveFilter;
      const isHomeHidden = item.dataset.homeHidden === 'true';
      const limitedByHomepage = activeArchiveFilter === 'all' && !archiveExpanded && isHomeHidden;
      item.hidden = !matchesFilter || limitedByHomepage;
    });

    if (archiveReveal) {
      archiveReveal.hidden = archiveExpanded || activeArchiveFilter !== 'all';
      archiveReveal.setAttribute('aria-expanded', String(archiveExpanded));
    }
  };

  if (archiveFilters.length && archiveItems.length) {
    archiveFilters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeArchiveFilter = filter.dataset.archiveFilter || 'all';
        archiveFilters.forEach((button) => {
          const isActive = button === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        applyArchiveFilter();
      });
    });

    reportArchiveCounts();
    applyArchiveFilter();
  }

  if (archiveReveal && archiveItems.length) {
    archiveReveal.addEventListener('click', () => {
      archiveExpanded = true;
      applyArchiveFilter();
    });
  }

  const visibleArchiveItems = () => Array.from(archiveItems).filter((item) => !item.hidden);

  const imageSourceForLightbox = (image) => {
    if (!image) return '';

    const explicitSource = image.getAttribute('src') || '';
    if (!explicitSource || /preview\.html(?:$|[?#])/.test(explicitSource)) return '';

    return new URL(explicitSource, window.location.href).href;
  };

  const setLightboxImage = (image) => {
    if (!lightboxImage || !image) return;

    const source = imageSourceForLightbox(image);
    if (!source) return;

    lightboxImage.src = source;
    lightboxImage.alt = image.alt || 'Street Archive image';
  };

  const openLightbox = (item) => {
    if (!archiveLightbox || !lightboxImage) return;

    const visibleItems = visibleArchiveItems();
    activeLightboxIndex = Math.max(0, visibleItems.indexOf(item));
    const image = item.querySelector('img');
    if (!image) return;

    setLightboxImage(image);
    archiveLightbox.hidden = false;
    document.body.classList.add('is-lightbox-open');
  };

  const moveLightbox = (direction) => {
    if (!archiveLightbox || archiveLightbox.hidden || !lightboxImage) return;

    const visibleItems = visibleArchiveItems();
    if (!visibleItems.length) return;

    activeLightboxIndex = (activeLightboxIndex + direction + visibleItems.length) % visibleItems.length;
    const image = visibleItems[activeLightboxIndex].querySelector('img');
    if (!image) return;

    setLightboxImage(image);
  };

  const closeLightbox = () => {
    if (!archiveLightbox) return;
    archiveLightbox.hidden = true;
    document.body.classList.remove('is-lightbox-open');
  };

  archiveItems.forEach((item) => {
    const trigger = item.querySelector('[data-lightbox-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', () => openLightbox(item));
  });

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxNext) lightboxNext.addEventListener('click', () => moveLightbox(1));
  if (lightboxPrev) lightboxPrev.addEventListener('click', () => moveLightbox(-1));

  if (archiveLightbox) {
    archiveLightbox.addEventListener('click', (event) => {
      if (event.target === archiveLightbox) closeLightbox();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (!archiveLightbox || archiveLightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowRight') moveLightbox(1);
    if (event.key === 'ArrowLeft') moveLightbox(-1);
  });

  if (!parallaxItems.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const move = () => {
    const viewport = window.innerHeight || 1;
    parallaxItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const offset = ((rect.top + rect.height / 2) - viewport / 2) / viewport;
      item.style.transform = `translateY(${offset * -18}px)`;
    });
  };

  window.addEventListener('scroll', move, { passive: true });
  move();
});
